export interface ITheme {
  colors:{
    white:string,
    red:string,
    silver:string,
    fallow:string,
    lightGray:string,
    darkGray:string,
    backgroundPutty:string,
    backgroundBlack:string,
    borderColor:string,
    dividerColor:string,
    backgroundGray:string,
    buttonBlack:string,
    textGray:string,
    borderGray:string
  },
  fonts:{
    primary:string
  },
  footerHeight:number,
  mediaQueryConstants:IMediaQueryConstants
}

export interface IMediaQueryConstants {
  desktopSmall:number,
  phone:number,
  phoneTiny:number,
  lowHeight:number,
  veryLowHeight:number
}

export const ifrTheme:ITheme = {
  colors: {
    white: '#ffffff',
    red: '#ff0000',
    silver: '#c0c0c0',
    fallow: '#c3a573',
    lightGray: '#ececec',
    darkGray: '#e4e4e4',
    backgroundPutty: '#c8a574',
    backgroundBlack: '#333333',
    borderColor:'#E3E3E3',
    dividerColor:"#CFCFCF",
    backgroundGray:'#F3F3F3',
    buttonBlack:'#191919',
    textGray:'#919191',
    borderGray:'#D7D7D7'
  },
  fonts: {
    primary: 'Montserrat',
  },
  footerHeight: 68,
  mediaQueryConstants: {
    desktopSmall: 920,
    phone: 810,
    phoneTiny: 400,
    lowHeight: 800,
    veryLowHeight: 700
  }
};

export const luxeTheme:ITheme = {
  colors: {
    white: '#ffffff',
    red: '#ff0000',
    silver: '#c0c0c0',
    fallow: '#c3a573',
    lightGray: '#ececec',
    darkGray: '#e4e4e4',
    backgroundPutty: '#c8a574',
    backgroundBlack: '#333333',
    borderColor:'#E3E3E3',
    dividerColor:"#CFCFCF",
    backgroundGray:'#F3F3F3',
    buttonBlack:'#191919',
    textGray:'#919191',
    borderGray:'#D7D7D7'
  },
  fonts: {
    primary: 'Soehne Breit',
  },
  footerHeight: 68,
  mediaQueryConstants: {
    desktopSmall: 920,
    phone: 810,
    phoneTiny: 400,
    lowHeight: 800,
    veryLowHeight: 700
  }
}

export const theme:ITheme = ifrTheme;